export const CLOUDINARY_CLOUD_NAME = `dn29xlaeh`
